import { ChevronLeft, CircleIcon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CardHeader } from "@/components/ui/card";
import { ReportTab } from "@/lib/constant";

type ReportViewHeaderProps = {
  onBack: () => void;
  tab: ReportTab;
  noteOnlyCorrect: boolean;
  onToggleFilter?: () => void;
};

function ReportViewHeader({ onBack, tab, noteOnlyCorrect, onToggleFilter }: ReportViewHeaderProps) {
  return (
    <CardHeader className="relative flex items-center justify-between px-5 sm:px-4">
      {/* 뒤로가기 버튼 */}
      <Button variant="ghost" size="icon" onClick={onBack}>
        <ChevronLeft className="size-5 text-muted-foreground" />
      </Button>

      <h1 className="text-base font-bold text-muted-foreground">Report</h1>

      {/* 필터 버튼 (잠금 상태일 때 숨김) */}
      {tab === ReportTab.NOTE && onToggleFilter && (
        <Button
          size="icon"
          className="absolute right-5 sm:right-4 w-fit px-2 flex items-center gap-1 bg-card"
          onClick={onToggleFilter}
        >
          {noteOnlyCorrect ? (
            <XIcon className="text-secondary size-3" />
          ) : (
            <CircleIcon className="text-primary size-3" />
          )}
          <span className="text-sm text-foreground">{noteOnlyCorrect ? "오답만" : "정답만"}</span>
        </Button>
      )}
      <div className="w-8" />
    </CardHeader>
  );
}

export default ReportViewHeader;
